import React from 'react'
import styled from 'styled-components'

const GroupStyles = styled.div`
  display: flex;
  margin-bottom: 10px;
  width: 100%;
  flex-direction: column;
`

const Group = props => {
  const { children } = props
  return <GroupStyles>{children}</GroupStyles>
}

export default Group
